import { basicAccountInfo } from "api/basic_account_info";
import { generic_get_api, generic_put_api } from "api/generic_api";
import { useState } from "react";
import { Component } from "react";
import { Button, Form } from 'react-bootstrap';
import { CODE_LABELS } from 'utils/constants';
import { EventNames, trackEvent } from 'utils/mixpanel';
import { ALL_DISTRICTS, INDIVIDUAL_DISTRICTS, ALL_SPUDS, ALL_USES } from "utils/sf_planning_constants";


const Stages = {
    NOOP: 'noop',
    FETCHING: 'fetching',
    SUBMITTING: 'submitting',
    COMPLETE: 'complete',
    ERROR: 'error',
}

const Pages = {
    DISTRICT: 'districts',
    TOPIC: 'topic',
}


class CodeLabels extends Component {

    constructor(props) {
        super(props);

        this.state = {
            parts: [],
            session_ok: false,
            stage: Stages.NOOP,
            page: null,
            merged_districts: null,
        };
        this.fetchCodeParts = this.fetchCodeParts.bind(this);
        this.saveParts = this.saveParts.bind(this);
        this.resetEverythingAndFetch = this.resetEverythingAndFetch.bind(this);
    }

    resetEverythingAndFetch() {
        this.setState(
            { parts: [], page: null, stage: Stages.NOOP, merged_districts: null }, () => this.fetchCodeParts(false));
    }

    fetchCodeParts(extract_districts) {
        this.setState({stage: Stages.FETCHING});

        generic_get_api(CODE_LABELS, {section: this.state.section, extract_districts: extract_districts})
        .then(
            data => {

                let cur_parts = data.parts;
                cur_parts.forEach((part) => {

                    part.districts_display = part.districts.join(" , ");
                    part.spuds_display = part.spuds.join(" , ");
                    part.heights_display = part.heights.join(" , ");
                    part.uses_display = part.uses.join(" | ");  // important because names can have commas

                    part.excluded_districts_display = part.excluded_districts.join(" , ");
                    part.excluded_spuds_display = part.excluded_spuds.join(" , ");
                    part.excluded_heights_display = part.excluded_heights.join(" , ");
                    part.zoning_categories_display = part.zoning_categories.join(" , ");
                });

                this.setState({
                    parts: cur_parts,
                    page: Pages.DISTRICT,
                    stage: Stages.NOOP,
                });
            }
        )
        .catch(error => {
        });
    }

    saveParts() {
        this.setState({stage: Stages.SAVING});
        
        const displayStringToList = (part, entry, separator) => {
            let final_list = [];
            let temp_list = part[entry].split(separator).map(s => s.trim());
            // remove empty strings
            temp_list.forEach((d) => {
                if (d.length > 0){
                    final_list.push(d);
                }
            });

            return final_list;
        }

        let cur_parts = this.state.parts;

        cur_parts.forEach((part) => {
            part.districts = displayStringToList(part, 'districts_display', ",");
            part.spuds = displayStringToList(part, 'spuds_display', ",");
            part.heights = displayStringToList(part, 'heights_display', ",");
            part.uses = displayStringToList(part, 'uses_display', "|");

            part.excluded_districts = displayStringToList(part, 'excluded_districts_display', ",");
            part.excluded_spuds = displayStringToList(part, 'excluded_spuds_display', ",");
            part.excluded_heights = displayStringToList(part, 'excluded_heights_display', ",");
            part.zoning_categories = displayStringToList(part, 'zoning_categories_display', ",");
        })

        generic_put_api(CODE_LABELS, 
            {   
                parts: this.state.parts,
            })
            .then(
                (result) => {
                    if(result.status === 204) {
                        this.setState(
                            {   
                                stage: Stages.COMPLETE,
                            });
                    }
                }
            ).catch(error => {
                this.setState({ stage: Stages.NOOP, });
            });
    }


    componentDidMount() {
        trackEvent(EventNames.PAGE_LOAD, {'data_1': 'code_parts'});
        basicAccountInfo()
        .then(
            data => {
                this.setState({session_ok: true});
            }
        ).catch(error => {
            if (error?.name === 'LOGIN_ERROR') {
                this.props.history.push('/login');
            }
        });

    }

    render() {
        const {parts, stage, section, page, merged_districts, show_excluded} = this.state;

        const setValue = (idx_in, key, value) => {
            let cur_parts = this.state.parts;

            cur_parts.forEach((part) => {
                if (part.idx === idx_in){
                    part[key] = value;
                }
            })
           
            this.setState({parts: cur_parts });      
        }

        const copyValueToAll = (idx_in, key) => {
            let cur_parts = this.state.parts;
            let value = ""

            cur_parts.forEach((part) => {
                if (part.idx === idx_in){
                    value = part[key];
                }
            })

            cur_parts.forEach((part) => {
                part[key] = value;
            })
            this.setState({parts: cur_parts }); 
        }

        const setZoningTable = (idx_in, value) => {
            
            let cur_parts = this.state.parts;

            cur_parts.forEach((part) => {
                if (part.idx === idx_in){
                    part.zoning_table = value;

                    if (value === false) {
                        part.parent = null;
                        part.detail_level = 'unknown';
                    }
                    else if (value === true) {
                        part.parent = null;
                        part.detail_level = 'primary';
                    }
                }
            })
           
            this.setState({parts: cur_parts });      
        }

        const canSubmit = () => {

            for (let i=0; i < this.state.parts.length; i++){
                let part = this.state.parts[i];

                if (part.zoning_table && part.detail_level == 'secondary' && !part.parent){
                    return false;
                }
                else if (part.zoning_table && (!part.detail_level || part.detail_level == 'unknown')){
                    return false;
                }
                else if(!part.zoning_categories_display) {
                    return false;
                }
                else if(!part.part_type || part.part_type == 'unknown') {
                    return false;
                }
            }
            return true;
        }

        const getMargin = (part) => {

            if(part.level === 1){
                return "row ms-2 mt-3";
            }
            else if(part.level === 2){
                return "row ms-4 mt-3";
            }
            else if(part.level === 3){
                return "row ms-5 mt-3";
            }
            else {
                return "row mt-3";
            }
        }

        const uniqueId = (name, idx) => {

            return name + "_" + idx;
        }
        
        const districtStyle = (idx_in, entry) => {
            let valid = true;
            let temp_district_list = [];
            
            const lowercasedList = ALL_DISTRICTS.map(str => str.toUpperCase());

            this.state.parts.forEach((part) => {
                if (part.idx === idx_in){
                    let district_string = part[entry];
                    temp_district_list = district_string.split(",").map(s => s.trim());
                }
            })
            
            temp_district_list.forEach((district) => {
                if (district && !lowercasedList.includes(district.toUpperCase())){
                    valid = false;
                }
            })
            
            if (valid) {
                return { fontSize: '0.75rem' }   
            }
            
            else {
                return { 
                    fontSize: '0.75rem',
                    borderColor: 'red',
                }   
            }
        }

        const spudStyle = (idx_in, entry) => {
            let valid = true;
            let temp_spuds_list = [];
            
            const upper_cased_list = ALL_SPUDS.map(str => str.toUpperCase());

            this.state.parts.forEach((part) => {
                if (part.idx === idx_in){
                    let spud_string = part[entry];
                    temp_spuds_list = spud_string.split(",").map(s => s.trim());
                }
            })
            
            temp_spuds_list.forEach((spud) => {
                if (spud && !upper_cased_list.includes(spud.toUpperCase())){
                    valid = false;
                }
            })
            
            if (valid) {
                return { fontSize: '0.75rem' }   
            }
            
            else {
                return { 
                    fontSize: '0.75rem',
                    borderColor: 'red',
                }   
            }
        }

        const usesStyle = (idx_in, entry) => {
            let valid = true;
            let temp_uses_list = [];
            
            const upper_cased_list = ALL_USES.map(str => str.toUpperCase());

            this.state.parts.forEach((part) => {
                if (part.idx === idx_in){
                    let uses_string = part[entry];
                    temp_uses_list = uses_string.split("|").map(s => s.trim());
                }
            })
            
            temp_uses_list.forEach((use) => {
                if (use && !upper_cased_list.includes(use.toUpperCase())){
                    valid = false;
                }
            })
            
            if (valid) {
                return { fontSize: '0.75rem' }   
            }
            
            else {
                return { 
                    fontSize: '0.75rem',
                    borderColor: 'red',
                }   
            }
        }

        const rowStyle = (idx_in) => {
            let is_table_row = false;

            this.state.parts.forEach((part) => {
                if (part.idx === idx_in){
                    if (part.is_table_row){
                        is_table_row = true;
                    }
                }
            })

            if (is_table_row) {
                return { backgroundColor: '#e2e2f4'}
            }
            else{
                return { border: "1px solid #ddd", borderRadius: "12px", padding: "10px", }
            }
        }

        const mergeDistricts = (type) => {
            let combined = [];
            const individual_list = INDIVIDUAL_DISTRICTS.map(str => str.toUpperCase());

            this.state.parts.forEach((part) => {
                let temp_districts_list = part.districts_display.split(",").map(s => s.trim());
    
                temp_districts_list.forEach((d) => {
                    if (d.length > 0 && !combined.includes(d)){

                        if(type === 'ALL' || individual_list.includes(d)) {
                            combined.push(d);
                        }
                    }
                });
            });
            this.setState({merged_districts: combined});
        }

        return(
            <div class="container-fluid codeLabels ps-4">
                {this.state.session_ok && 
                    <div class="row">
                        <div class="col-auto me-3">
                            <input type="text" class="form-control" value={section} placeholder="section" onChange={(e) => this.setState({section: e.target.value})}/> 
                            
                        </div>
                        <div class="col-auto me-3 text-start">
                            <Button variant="secondary" onClick={ this.resetEverythingAndFetch }>OK</Button>
                        </div>
                         <div class="col-auto me-3 text-start">
                            <Button variant="secondary" onClick={ () => this.fetchCodeParts(true) }>Fetch Districts</Button>
                        </div>
                    </div>
                }
                {
                    stage == Stages.COMPLETE &&
                    <div class="row mt-2">
                        <div class="col text-danger fw-bold">Complete</div>
                    </div>
                }
                {
                    stage === Stages.FETCHING && 
                    <div class="container mt-5 text-center">
                        <span class="spinner-border" aria-hidden="true"></span>
                    </div>
                }
                
                {  
                    page === Pages.DISTRICT &&
                    <>
                        <div class="row">
                            <div class="col-6"></div>
                            <div class="col-3">
                                <div class="row me-1">
                                    <textarea 
                                        class="form-control" 
                                        rows="3" 
                                        value={merged_districts}
                                        style={{ fontSize: '0.75rem' }}
                                    />
                                </div>
                                <div class="row me-1">
                                    <div class="col">
                                        <Button onClick={() => mergeDistricts('ALL')} size="sm" variant="outline-primary">ALL</Button>
                                    </div>
                                    <div class="col">
                                        <Button onClick={() => mergeDistricts('INDIVIDUAL')} size="sm" variant="outline-primary">Individual</Button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-2"></div>
                            <div class="col-1"></div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <a className="text-decoration-underline" role="button" onClick={() => this.setState({show_excluded: !this.state.show_excluded})}>Show/Hide Excluded</a>
                            </div>
                        </div>

                        {parts.map((part, index) => {
                            return <div class={getMargin(part)} style={rowStyle(part.idx)}>
                                    <div class="row fw-bold">
                                       
                                        <div class="col text-end pe-0">
                                            <input 
                                                class="form-check-input" 
                                                type="checkbox" 
                                                value="" 
                                                id={uniqueId("operatorId", part.idx)}
                                                checked={part.or_operator} 
                                                onChange={(e) => setValue(part.idx, 'or_operator', e.target.checked)}/>
                                        </div>
                                        <div class="col-auto text-end">Is OR</div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-6">
                                            <div class="row">
                                                {
                                                    <>
                                                        { part.subsection ?
                                                            <div class="col-auto pe-0 subsection">({part.subsection})</div>
                                                            :
                                                            <div class="col-auto pe-0 subsection">&nbsp;&nbsp;&nbsp;</div>
                                                        }
                                                        
                                                        <div class="col sectionText">
                                                            {part.text}
                                                        </div>
                                                    </>
                                                   
                                                }
                                            </div>
                                        </div>
                                        <div class="col-3">
                                            <div class="row me-1">
                                                <textarea 
                                                    class="form-control" 
                                                    style={districtStyle(part.idx, 'districts_display')} 
                                                    rows="3" 
                                                    value={part.districts_display}
                                                    onChange={(e) => setValue(part.idx, 'districts_display', e.target.value)}
                                                />
                                            </div>
                                            <div class="row me-1">
                                                <Button onClick={() => copyValueToAll(part.idx, 'districts_display')} size="sm" variant="outline-primary"><i class="fa-solid fa-file-import"></i></Button>
                                            </div>
                                            
                                        </div>
                                        <div class="col-2">
                                            <div class="row me-1">
                                                <textarea 
                                                class="form-control"  
                                                style={spudStyle(part.idx, 'spuds_display')}  
                                                rows="3" value={part.spuds_display}
                                                onChange={(e) => setValue(part.idx, 'spuds_display', e.target.value)}/>
                                            </div>
                                            <div class="row me-1">
                                                <Button onClick={() => copyValueToAll(part.idx, 'spuds_display')} size="sm" variant="outline-primary"><i class="fa-solid fa-file-import"></i></Button>
                                            </div>
                                            
                                        </div>
                                        <div class="col-1"> 
                                            <div class="row">
                                                <textarea class="form-control" style={{ fontSize: '0.75rem' }} rows="3" value={part.heights_display}
                                                onChange={(e) => setValue(part.idx, 'heights_display', e.target.value)}/>
                                            </div>
                                            <div class="row">
                                                <Button onClick={() => copyValueToAll(part.idx, 'heights_display')} size="sm" variant="outline-primary"><i class="fa-solid fa-file-import"></i></Button>
                                            </div>
                                            
                                        </div>
                                        
                                    </div>
                                    
                                    { show_excluded && 
                                        <div class="row mt-3">
                                            <div class="col-6">
                                            </div>
                                            <div class="col-3">
                                                <div class="row me-1">
                                                    <textarea 
                                                        class="form-control" 
                                                        style={districtStyle(part.idx, 'excluded_districts_display')} 
                                                        rows="1" 
                                                        value={part.excluded_districts_display}
                                                        onChange={(e) => setValue(part.idx, 'excluded_districts_display', e.target.value)}
                                                    />
                                                </div>
                                                <div class="row me-1">
                                                    <Button onClick={() => copyValueToAll(part.idx, 'excluded_districts_display')} size="sm" variant="outline-primary"><i class="fa-solid fa-file-import"></i></Button>
                                                </div>
                                                
                                            </div>
                                            <div class="col-2">
                                                <div class="row me-1">
                                                    <textarea 
                                                        class="form-control"  
                                                        style={spudStyle(part.idx, 'excluded_spuds_display')} 
                                                        rows="1" value={part.excluded_spuds_display}
                                                        onChange={(e) => setValue(part.idx, 'excluded_spuds_display', e.target.value)}/>
                                                </div>
                                                <div class="row me-1">
                                                    <Button onClick={() => copyValueToAll(part.idx, 'excluded_spuds_display')} size="sm" variant="outline-primary"><i class="fa-solid fa-file-import"></i></Button>
                                                </div>
                                                
                                            </div>
                                            <div class="col-1"> 
                                                <div class="row">
                                                    <textarea class="form-control" style={{ fontSize: '0.75rem' }} rows="1" value={part.excluded_heights_display}
                                                    onChange={(e) => setValue(part.idx, 'excluded_heights_display', e.target.value)}/>
                                                </div>
                                                <div class="row">
                                                    <Button onClick={() => copyValueToAll(part.idx, 'excluded_heights_display')} size="sm" variant="outline-primary"><i class="fa-solid fa-file-import"></i></Button>
                                                </div>
                                                
                                            </div>
                                            
                                        </div>
                                    }
                                </div>  
                        })}
                        <div class="row mt-4"><div class="col"><Button onClick={() => this.setState({page: Pages.TOPIC})}>Next</Button></div></div>
                    </>
                }
                {  
                    page === Pages.TOPIC &&
                    <>
                        {parts.map((part, index) => {
                            return <div class={getMargin(part)} style={rowStyle(part.idx)}>
                                    <div class="row">
                                        <div class="col-6">
                                            <div class="row">
                                                <div class="col-auto"><small>{part.idx}</small></div>
                                            </div>
                                             <div class="row">
                                                {
                                                    <>
                                                        { part.subsection ?
                                                            <div class="col-auto pe-0 subsection">({part.subsection})</div>
                                                            :
                                                            <div class="col-auto pe-0 subsection">&nbsp;&nbsp;&nbsp;</div>
                                                        }
                                                        {
                                                            part.is_table_row ? 
                                                            <textarea 
                                                                class="form-control" 
                                                                rows="3"
                                                                style={{ fontSize: '0.75rem' }}
                                                                value={part.text}
                                                                onChange={(e) => setValue(part.idx, 'text', e.target.value)}
                                                            />
                                                            :
                                                            <div class="col sectionText">{part.text}</div>
                                                        }
                                                        
                                                    </>
                                                   
                                                }
                                            </div>
                                        </div>
                                        <div class="col-2">
                                            <div class="row">
                                                <div class="col">
                                                    <input class="form-control" placeholder="zoning_categories" value={part.zoning_categories_display} onChange={(e) => setValue(part.idx, 'zoning_categories_display', e.target.value)}/>
                                                </div>
                                                <div class="col-auto  ps-0 pe-0">
                                                    <Button onClick={() => copyValueToAll(part.idx, 'zoning_categories_display')} size="sm" variant="outline-primary"><i class="fa-solid fa-file-import"></i></Button>
                                                </div>
                                            </div>
                                             
                                            <div class="row mt-2">
                                                <div class="col">
                                                    <select 
                                                    name={uniqueId("partType", part.idx)} 
                                                    key={uniqueId("partType", part.idx)} 
                                                    class="form-control" 
                                                    onChange={(e)=>setValue(part.idx, 'part_type', e.target.value) }>
                                                        <option selected={part.part_type === "unknown"} value="unknown">Part type</option>
                                                        <option value="rule" selected={part.part_type === "rule"}>Rule</option>
                                                        <option value="definition" selected={part.part_type === "definition"}>Definition</option>
                                                        <option value="special_case" selected={part.part_type === "special_case"}>Special case</option>
                                                        <option value="other" selected={part.part_type === "other"}>Other</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="row mt-2">
                                                <div class="col">
                                                    <select 
                                                    name={uniqueId("ruleRank", part.idx)} 
                                                    key={uniqueId("ruleRank", part.idx)} 
                                                    class="form-control" 
                                                    onChange={(e)=>setValue(part.idx, 'rule_rank', e.target.value) }>
                                                        <option value="1" selected={part.rule_rank === "1"}>Rank 1</option>
                                                        <option value="0" selected={part.rule_rank === "0"}>Rank 0</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-2">
                                            <div class="row">  
                                                <div class="col-auto pe-0">
                                                    <input 
                                                        class="form-check-input" 
                                                        type="checkbox" 
                                                        value="" 
                                                        id={uniqueId("checkZoneTable", part.idx)}
                                                        checked={part.zoning_table} 
                                                        onChange={(e) => setZoningTable(part.idx, e.target.checked)}/>
                                                </div>
                                                <div class="col">
                                                    <label class="form-check-label" for="checkZoneTable">
                                                        Zoning table
                                                    </label>
                                                </div>
                                            </div>
                                            { part.zoning_table && 
                                            <> 
                                                <div class="row  mt-2"><div class="col">
                                                    <select 
                                                        name={uniqueId("paragraphLevel", part.idx)} 
                                                        key={uniqueId("paragraphLevel", part.idx)} 
                                                        class="form-control" onChange={(e)=>setValue(part.idx, 'detail_level', e.target.value) }>
                                                        <option selected={part.detail_level === "unknown"} value="unknown">Detail level unknown</option>
                                                        <option value="primary" selected={part.detail_level === "primary"}>Primary</option>
                                                        <option value="secondary" selected={part.detail_level === "secondary"}>Secondary</option>
                                                        <option value="hidden" selected={part.detail_level === "hidden"}>Hidden</option>
                                                    </select>
                                                </div></div>
                                                <div class="row  mt-2"><div class="col">
                                                    <input class="form-control" placeholder="Parent" value={part.parent} onChange={(e) => setValue(part.idx, 'parent', e.target.value)}/>
                                                </div></div>
                                            </>
                                            }
                                        </div>
                                        <div class="col-2">
                                            <div class="row">
                                                <textarea 
                                                    class="form-control" 
                                                    rows="3" 
                                                    value={part.uses_display}
                                                    style={usesStyle(part.idx, 'uses_display')} 
                                                    onChange={(e) => setValue(part.idx, 'uses_display', e.target.value)}
                                                />
                                            </div>
                                            <div class="row">
                                                <Button onClick={() => copyValueToAll(part.idx, 'uses_display')} size="sm" variant="outline-primary"><i class="fa-solid fa-file-import"></i></Button>
                                            </div>
                                            <div class="row mt-2">
                                                <div class="col">
                                                    <input class="form-control" placeholder="Sub topic" value={part.sub_topic} onChange={(e) => setValue(part.idx, 'sub_topic', e.target.value)}/>
                                                </div>
                                                <div class="col-auto  ps-0 pe-0">
                                                    <Button onClick={() => copyValueToAll(part.idx, 'sub_topic')} size="sm"  variant="outline-primary" ><i class="fa-solid fa-file-import"></i></Button>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                        
                                </div>  
                        })}
                        {
                            stage === Stages.SAVING ?
                            <div class="container mt-5 text-center">
                                <span class="spinner-border" aria-hidden="true"></span>
                            </div> 
                            :
                            <div class="row mt-4">
                                <div class="col-auto">
                                    <Button onClick={() => this.setState({page: Pages.DISTRICT})}>Back</Button>
                                </div>
                                <div class="col-auto">
                                    <Button onClick={this.saveParts} disabled={!canSubmit()}>Submit</Button>
                                </div>
                            </div>
                        }
                    </>
                }
            </div>
        )
    }
}
CodeLabels.displayName = "CodeLabels";
export default CodeLabels;